import { phosphorCheckCircleFill, phosphorXCircleFill } from '@ng-icons/phosphor-icons/fill';
import {
  phosphorArchive,
  phosphorArrowClockwise,
  phosphorArrowCounterClockwise,
  phosphorArrowLeft,
  phosphorArrowRight,
  phosphorArrowSquareOut,
  phosphorArrowsClockwise,
  phosphorArrowsDownUp,
  phosphorArrowsIn,
  phosphorArrowsLeftRight,
  phosphorArrowsOut,
  phosphorArrowsOutCardinal,
  phosphorArrowsOutSimple,
  phosphorBook,
  phosphorBooks,
  phosphorBookOpenText,
  phosphorCalendar,
  phosphorCaretDoubleLeft,
  phosphorCaretDoubleRight,
  phosphorCaretDown,
  phosphorCaretLeft,
  phosphorCaretRight,
  phosphorCaretUp,
  phosphorChartBar,
  phosphorCheck,
  phosphorCheckCircle,
  phosphorClipboardText,
  phosphorClock,
  phosphorCloudArrowUp,
  phosphorColumns,
  phosphorCopy,
  phosphorCrosshair,
  phosphorCrosshairSimple,
  phosphorCubeFocus,
  phosphorCubeTransparent,
  phosphorDatabase,
  phosphorDotsSixVertical,
  phosphorDotsThree,
  phosphorDotsThreeVertical,
  phosphorDownloadSimple,
  phosphorEye,
  phosphorFile,
  phosphorFunnel,
  phosphorGear,
  phosphorGearSix,
  phosphorGitDiff,
  phosphorGridFour,
  phosphorHeadphones,
  phosphorHouse,
  phosphorImage,
  phosphorInfo,
  phosphorList,
  phosphorLockKey,
  phosphorMagnifyingGlass,
  phosphorMinus,
  phosphorNote,
  phosphorNotePencil,
  phosphorPencilSimple,
  phosphorPencilSimpleLine,
  phosphorPlus,
  phosphorPrinter,
  phosphorProhibit,
  phosphorRuler,
  phosphorShapes,
  phosphorSignOut,
  phosphorSliders,
  phosphorSquaresFour,
  phosphorStack,
  phosphorStorefront,
  phosphorTag,
  phosphorTrash,
  phosphorTrayArrowDown,
  phosphorTreeStructure,
  phosphorUploadSimple,
  phosphorUser,
  phosphorUserCircle,
  phosphorUsers,
  phosphorVectorThree,
  phosphorWarning,
  phosphorWarningCircle,
  phosphorX,
  phosphorXCircle,
  phosphorRows,
  phosphorListDashes,
} from '@ng-icons/phosphor-icons/regular';

export const TFS_ICON_REGISTRY = {
  archive: phosphorArchive,
  'arrow-clockwise': phosphorArrowClockwise,
  'arrow-counter-clockwise': phosphorArrowCounterClockwise,
  'arrow-left': phosphorArrowLeft,
  'arrow-right': phosphorArrowRight,
  'arrow-square-out': phosphorArrowSquareOut,
  'arrows-clockwise': phosphorArrowsClockwise,
  'arrows-down-up': phosphorArrowsDownUp,
  'arrows-in': phosphorArrowsIn,
  'arrows-left-right': phosphorArrowsLeftRight,
  'arrows-out': phosphorArrowsOut,
  'arrows-out-cardinal': phosphorArrowsOutCardinal,
  'arrows-out-simple': phosphorArrowsOutSimple,
  book: phosphorBook,
  'book-open-text': phosphorBookOpenText,
  books: phosphorBooks,
  calendar: phosphorCalendar,
  'caret-double-left': phosphorCaretDoubleLeft,
  'caret-double-right': phosphorCaretDoubleRight,
  'caret-down': phosphorCaretDown,
  'caret-left': phosphorCaretLeft,
  'caret-right': phosphorCaretRight,
  'caret-up': phosphorCaretUp,
  'chart-bar': phosphorChartBar,
  check: phosphorCheck,
  'check-circle': phosphorCheckCircle,
  'check-circle-fill': phosphorCheckCircleFill,
  'clipboard-text': phosphorClipboardText,
  clock: phosphorClock,
  'cloud-arrow-up': phosphorCloudArrowUp,
  columns: phosphorColumns,
  copy: phosphorCopy,
  crosshair: phosphorCrosshair,
  'cube-focus': phosphorCubeFocus,
  'cube-transparent': phosphorCubeTransparent,
  database: phosphorDatabase,
  'dots-six-vertical': phosphorDotsSixVertical,
  'dots-three': phosphorDotsThree,
  'dots-three-vertical': phosphorDotsThreeVertical,
  'download-simple': phosphorDownloadSimple,
  eye: phosphorEye,
  file: phosphorFile,
  funnel: phosphorFunnel,
  gear: phosphorGear,
  'gear-six': phosphorGearSix,
  'git-diff': phosphorGitDiff,
  'grid-four': phosphorGridFour,
  headphones: phosphorHeadphones,
  house: phosphorHouse,
  image: phosphorImage,
  info: phosphorInfo,
  list: phosphorList,
  'list-dashes': phosphorListDashes,
  'lock-key': phosphorLockKey,
  'magnifying-glass': phosphorMagnifyingGlass,
  minus: phosphorMinus,
  note: phosphorNote,
  'note-pencil': phosphorNotePencil,
  'pencil-simple': phosphorPencilSimple,
  'pencil-simple-line': phosphorPencilSimpleLine,
  plus: phosphorPlus,
  printer: phosphorPrinter,
  prohibit: phosphorProhibit,
  rows: phosphorRows,
  ruler: phosphorRuler,
  shapes: phosphorShapes,
  'sign-out': phosphorSignOut,
  sliders: phosphorSliders,
  'squares-four': phosphorSquaresFour,
  stack: phosphorStack,
  storefront: phosphorStorefront,
  tag: phosphorTag,
  trash: phosphorTrash,
  'tray-arrow-down': phosphorTrayArrowDown,
  'tree-structure': phosphorTreeStructure,
  'upload-simple': phosphorUploadSimple,
  user: phosphorUser,
  'user-circle': phosphorUserCircle,
  users: phosphorUsers,
  'vector-three': phosphorVectorThree,
  warning: phosphorWarning,
  'warning-circle': phosphorWarningCircle,
  x: phosphorX,
  'x-circle': phosphorXCircle,
  'x-circle-fill': phosphorXCircleFill,

  // --- Legacy aliases: old custom icon names → canonical Phosphor SVG. ---
  // Aliasing has zero bundle cost (same import referenced twice). Prefer the
  // canonical Phosphor name in new code.
  'alert-circle': phosphorWarningCircle,
  'alert-triangle': phosphorWarning,
  'arrow-swap': phosphorArrowsLeftRight,
  'arrows-direction': phosphorArrowsOutCardinal,
  assembly: phosphorTreeStructure,
  'check-circle-2': phosphorCheckCircle,
  'chevron-down': phosphorCaretDown,
  'chevron-left': phosphorCaretLeft,
  'chevron-right': phosphorCaretRight,
  'chevron-up': phosphorCaretUp,
  'cloud-plus': phosphorCloudArrowUp,
  'cloud-upload': phosphorCloudArrowUp,
  'crosshair-simple': phosphorCrosshairSimple,
  compare: phosphorGitDiff,
  contract: phosphorArrowsIn,
  cross: phosphorX,
  download: phosphorDownloadSimple,
  'download-outlined': phosphorDownloadSimple,
  edit: phosphorNotePencil,
  expand: phosphorArrowsOut,
  'external-link': phosphorArrowSquareOut,
  first: phosphorCaretDoubleLeft,
  'grid-1': phosphorSquaresFour,
  'headphones-2': phosphorHeadphones,
  last: phosphorCaretDoubleRight,
  'log-out': phosphorSignOut,
  logout: phosphorSignOut,
  'manual-item': phosphorPencilSimpleLine,
  maximize: phosphorArrowsOutSimple,
  menu: phosphorList,
  'more-1': phosphorDotsThree,
  'more-2': phosphorDotsThreeVertical,
  'note-add': phosphorNotePencil,
  profile: phosphorUserCircle,
  redo: phosphorArrowClockwise,
  'refresh-ccw': phosphorArrowCounterClockwise,
  'refresh-cw': phosphorArrowClockwise,
  search: phosphorMagnifyingGlass,
  settings: phosphorGear,
  slash: phosphorProhibit,
  sort: phosphorArrowsDownUp,
  store: phosphorStorefront,
  'tool-comparison': phosphorGitDiff,
  undo: phosphorArrowCounterClockwise,
  upload: phosphorUploadSimple,
} as const satisfies Record<string, string>;

export type TfsIconName = keyof typeof TFS_ICON_REGISTRY;
export type TfsIconSize = 16 | 20 | 24 | 32;
export type TfsIconWeight = 'regular';
